import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { AlertComponent } from './dialog/alert.component';
import { UppercaseInputDirective } from './services/uppercase-input.directive';
import { PreserveHtmlPipe } from './services/preserve-html.pipe';
import { FocusFirstInvalidFieldDirective } from './services/form.directive';
import { ScrollTopComponent } from './scroll-top/scroll-top.component';
import { TimerComponent } from './timer/timer.component';
import { DataService } from './services/data.service';
import { EventBusService } from './services/event-bus.service';
import { CustommatdateService } from './services/custommatdate.service';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatNativeDateModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { HttpClientModule } from '@angular/common/http';
import { MomentDateModule } from '@angular/material-moment-adapter';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { A11yModule } from '@angular/cdk/a11y';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { PIERHIPPDEMOComponent } from './pierhippdemo.component';
import { DemoformComponent } from './demoform/demoform.component';

@NgModule({
  
    imports: [
        BrowserModule,
        CommonModule,
        FormsModule,
        BrowserAnimationsModule,
        MatStepperModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatSelectModule,
        MatNativeDateModule,
        MatProgressSpinnerModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatRadioModule,
        MatDialogModule,
        ReactiveFormsModule,
        HttpClientModule,
        MomentDateModule,
        MatTooltipModule,
        MatIconModule,
        MatListModule,
        MatCardModule,
        A11yModule,
        NgOptimizedImage,
        MatSlideToggleModule,
        MatChipsModule,
        MatAutocompleteModule
    ],
  declarations: [PIERHIPPDEMOComponent,
    DemoformComponent,
    AlertComponent,
    UppercaseInputDirective,
    PreserveHtmlPipe,
    FocusFirstInvalidFieldDirective,
    ScrollTopComponent,
    TimerComponent,

  ],providers: [
    DataService,
    EventBusService,
    CustommatdateService,
    { provide: 'Window', useFactory: () => window },
],
})
export class PierhippdemoModule { }
